import { SimEventKind } from "./events";
import type { LevelSim } from "./levelSim";
import type { PetSystem } from "./petSystem";
import { withinBark } from "./troopRules";

/**
 * Rally Bark (Pets v2, docs/PETS.md): a bark is due every `everyTicks` of running waves; it goes off once a fortress
 * troop stands within `reach` of the flag (a due bark waits for one, so it is never wasted on an empty flag), and for
 * `durationTicks` the fortress troops within reach deal +`damagePercent` and take −`guardPercent` of a raider's blow
 * (TroopSystem.bark, measured per troop at each strike: one that walks out of reach loses it). Barracks soldiers fight
 * for their tower and are not the fortress's: they take no part.
 */
export function tickBark(sim: LevelSim, pet: PetSystem): void {
  const bark = pet.rule.bark, buff = pet.barkBuff;
  if (!bark || buff === null) return;
  if (pet.barkLeft > 0) pet.barkLeft--;
  if (pet.barkTimer > 0) pet.barkTimer--;
  if (pet.barkTimer <= 0) {
    const r = sim.troops.rally;
    let near = 0;
    for (const t of sim.troops.slots) if (t.alive && withinBark(buff, r.x, r.y, t.x, t.y)) near++;
    if (near > 0) {
      pet.barkLeft = bark.durationTicks;
      pet.barkTimer = bark.everyTicks;
      sim.events.add(SimEventKind.PetBarked, near, bark.durationTicks);
    }
  }
  sim.troops.bark = pet.barkLeft > 0 ? buff : null;
}
